import React from "react";
import Check from "../../assets/assets/check-circle.svg";
import ContinueCertification from "./ContinueCertification";
import { useHistory } from "react-router-dom";
import { PropTypes } from 'prop-types';

const DeviceStatus = ({ trail, userType, canEdit = false, EditableCertificationName }) => {
  const history = useHistory();


  const superStatus = trail && trail.nibss_super_admin_status;
  const status = trail && trail.status;
  const companyId = trail && trail.company_id;
  const docUpload =
    trail &&
    trail.trail &&
    trail.trail.user &&
    trail.trail.user.docUploadStatus;
  const paymentMade =
    trail &&
    trail.trail &&
    trail.trail.user &&
    trail.trail.user.paymentUploadStatus;
  const demoSchedule =
    trail &&
    trail.trail &&
    trail.trail.user &&
    trail.trail.user.demoScheduleStatus;
  const certificateAssigned =
    trail &&
    trail.trail &&
    trail.trail.admin &&
    trail.trail.admin.certificateAssigned;

  const update = (id, type) => {
    let payload = {
      id: id,
      status: status,
      nibss_super_admin_status: superStatus,
      company_id: companyId,
    };
    if (type === "pos_device_certification") {
      history.push({
        pathname: "/device/update",
        state: payload,
      });
    }
    if (type === "pos_application_certification") {
      history.push({
        pathname: "/application/update",
        state: payload,
      });
    }
  };

   

  return (
    <div className="status-display">
      <div>
      <div className="flex items-center gap-4 flex-wrap">
  <h1 className="certification-name text-lg font-semibold whitespace-nowrap overflow-hidden text-ellipsis max-w-[70%]">
    {`${trail.application_type === "pos_device_certification" 
        ? `${trail.device_name} ${trail.version}` 
        : `${trail.request_doc_28_url} ${trail.request_doc_27_url}`
      }`
      .charAt(0).toUpperCase() +
      `${trail.application_type === "pos_device_certification" 
        ? `${trail.device_name} ${trail.version}` 
        : `${trail.request_doc_28_url} ${trail.request_doc_27_url}`
      }`.slice(1)
    }<span style={{fontSize: '1.1rem', position: 'relative', top: '-0.2em'}}>{` | POS ${trail.application_type === "pos_device_certification" ? "Device" : "Application"} Name`}</span>
  </h1>



    <div className="shrink-0">
    {trail && trail?.admin?.certificateAssigned && (

      <EditableCertificationName 
        key={trail.id}
        trail={trail}
        canEdit={canEdit}
        applicationId={trail?.id}
        companyId={trail?.application_info?.company_id}
      />
 )}
    </div>
 
</div>
         
      
        <h4 className="cert-status">
          Acceptance Status:
          {status === "approved" && superStatus === "approved" && (
            <span className="approved">{superStatus}</span>
          )}
          {status === "pending" && superStatus !== "rejected" && (
            <span className="pending">{superStatus}</span>
          )}
          {(status === "rejected" || superStatus === "rejected") && (
            <span className="rejected">Rejected</span>
          )}
          {(status === "certfication_requirements_in_progress" ||
            superStatus === "certfication_requirements_in_progress") && (
            <span className="pending">Certification in progress</span>
          )}
        </h4>
        <div className="progress-status">
          <div className="check-circle-flex">
            <p>
              POS Certification <br />
              Documents Submission
            </p>
            {docUpload === true ? (
              <div className="check-circle">
                <img src={Check} alt="check" />
              </div>
            ) : (
              <div className="check-circle2">1</div>
            )}
          </div>
          <div className="check-circle-flex">
            <p className="second">Payment Made</p>
            {paymentMade === true ? (
              <div className="check-circle">
                <img src={Check} alt="check" />
              </div>
            ) : (
              <div className="check-circle2">2</div>
            )}
          </div>
          <div className="check-circle-flex">
            <p className="fourth">
              Schedule <br />
              Demo
            </p>
            {demoSchedule === true ? (
              <div className="check-circle">
                <img src={Check} alt="check" />
              </div>
            ) : (
              <div className="check-circle2">3</div>
            )}
          </div>
          <div className="check-circle-flex">
            <p className="sixth">
              Device <br />
              Certificate Approved
            </p>
            {certificateAssigned === true ? (
              <div className="check-circle">
                <img src={Check} alt="check" />
              </div>
            ) : (
              <div className="check-circle2">4</div>
            )}
          </div>
        </div>
        <div className="progress">
          <div className="check-circle-sec">
            <div className="line-full"></div>
          </div>
        </div>
      </div>
      {certificateAssigned !== true &&
      userType !== "staff" &&
      (status === "rejected" || superStatus === "rejected") ? (
        <div className="status-display-right">
          <div className="continue-sec">
            <button
              data-testid="updatedevice"
              className="continue-sec-btn"
              onClick={() => update(trail.id, trail.application_type)}
            >
              update
            </button>
          </div>
        </div>
      ) : certificateAssigned !== true && userType !== "staff" ? (
        <div className="status-display-right">
          <ContinueCertification
            appId={trail && trail.id}
            renewalCount={trail && trail.renewal_count}
            companyId={trail && trail.company_id}
            user={trail && trail.trail && trail.trail.user}
            admin={trail && trail.trail && trail.trail.admin}
            type={trail && trail.application_type}
            tid={trail && trail.tid}
            portNo={trail && trail.port_number}
          />
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
};

DeviceStatus.propTypes = {
  userType: PropTypes.string,
  trail: PropTypes.object
}

export default DeviceStatus;
